/* Warm Style — header: countdown, search, menu drawer, cart drawer (AJAX). */
(() => {
  if (window.__wsHeader) return; window.__wsHeader = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    const fmt = window.wsMoneyFormat || '{{amount_with_comma_separator}} €';
    const n = (v, p, t, d) => { const s = (v / 100).toFixed(p).split('.'); return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (s[1] ? d + s[1] : ''); };
    const key = (fmt.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
    const map = { amount: n(cents, 2, ',', '.'), amount_no_decimals: n(cents, 0, ',', '.'), amount_with_comma_separator: n(cents, 2, '.', ','), amount_no_decimals_with_comma_separator: n(cents, 0, '.', ','), amount_with_space_separator: n(cents, 2, ' ', ',') };
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, map[key] || map.amount);
  }
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- panels ---------- */
  let lastFocus = null;
  function open(name) {
    const p = $(`[data-wsh-panel="${name}"]`); if (!p) return false;
    lastFocus = document.activeElement;
    p.hidden = false;
    if (name === 'search') { $('input[type=search]', p)?.focus(); return true; }
    document.body.classList.add('wsh-locked');
    requestAnimationFrame(() => requestAnimationFrame(() => p.classList.add('is-open')));
    setTimeout(() => $('.wsh-drawer__close', p)?.focus(), 50);
    if (name === 'cart') refreshCart();
    return true;
  }
  function close(p) {
    if (!p || p.hidden) return;
    if (p.dataset.wshPanel === 'search') { p.hidden = true; return; }
    p.classList.remove('is-open');
    setTimeout(() => { p.hidden = true; }, 300);
    if (!$$('.wsh-drawer.is-open').length) document.body.classList.remove('wsh-locked');
    lastFocus?.focus?.();
  }
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-wsh-open]');
    if (o) { if (open(o.dataset.wshOpen)) e.preventDefault(); return; }
    const c = e.target.closest('[data-wsh-close]');
    if (c) close(c.closest('[data-wsh-panel]'));
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') $$('[data-wsh-panel]:not([hidden])').forEach(close); });

  /* ---------- countdown ---------- */
  const pad = n => String(n).padStart(2, '0');
  function tick() {
    const now = new Date();
    $$('[data-wsh-countdown]').forEach(el => {
      let end = el.dataset.end ? new Date(el.dataset.end) : null;
      if (!end || isNaN(end) || end < now) end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      const l = end - now, h = Math.floor(l / 3.6e6);
      el.textContent = (h >= 24 ? Math.floor(h / 24) + 'j ' + pad(h % 24) : pad(h)) + ':' + pad(Math.floor(l / 6e4) % 60) + ':' + pad(Math.floor(l / 1000) % 60);
    });
  }
  tick(); setInterval(tick, 1000);

  /* ---------- cart ---------- */
  function setCount(n) {
    $$('[data-wsh-count]').forEach(el => { el.textContent = n; el.hidden = n === 0; });
    $$('[data-wsh-count-plain]').forEach(el => el.textContent = n);
  }
  function renderCart(cart) {
    const drawer = $('[data-ws-cart]'); if (!drawer) return;
    setCount(cart.item_count);
    const wrap = $('[data-wsh-items]', drawer);
    if (!cart.items.length) wrap.innerHTML = `<p class="wsh-cart__empty">${esc($('.wsh-cart__empty', drawer)?.textContent || 'Votre panier est vide.')}</p>`;
    else wrap.innerHTML = cart.items.map(it => {
      const img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160_crop_center$1$2') : '';
      const orig = it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : '';
      const disc = (it.line_level_discount_allocations || []).map(d => `<span class="wsh-line__disc">${esc(d.discount_application.title)} (−${money(d.amount)})</span>`).join('');
      const meta = [it.variant_title, ...Object.entries(it.properties || {}).filter(([k]) => !k.startsWith('_')).map(([k, v]) => `${k} : ${v}`)].filter(Boolean).map(esc).join(' · ');
      return `<div class="wsh-line" data-key="${esc(it.key)}">
        ${img ? `<img class="wsh-line__img" src="${esc(img)}" alt="" loading="lazy">` : '<span class="wsh-line__img"></span>'}
        <div class="wsh-line__body">
          <a class="wsh-line__title" href="${esc(it.url)}">${esc(it.product_title)}</a>
          ${meta ? `<span class="wsh-line__meta">${meta}</span>` : ''}${disc}
          <div class="wsh-line__row">
            <div class="wsh-qty"><button type="button" data-q="${it.quantity - 1}" aria-label="Diminuer">−</button><span>${it.quantity}</span><button type="button" data-q="${it.quantity + 1}" aria-label="Augmenter">+</button></div>
            <div class="wsh-line__price"><b>${money(it.final_line_price)}</b>${orig}</div>
          </div>
          <button type="button" class="wsh-line__remove" data-q="0">Retirer</button>
        </div></div>`;
    }).join('');
    $('[data-wsh-total]', drawer).textContent = money(cart.total_price);
    const dr = $('[data-wsh-discount-row]', drawer);
    if (dr) { dr.hidden = !cart.total_discount; $('[data-wsh-discount]', drawer).textContent = '−' + money(cart.total_discount); }
    const th = +drawer.dataset.freeThreshold;
    if (th > 0) {
      const left = Math.max(0, th - cart.total_price);
      $('[data-wsh-free-text]', drawer).textContent = left ? drawer.dataset.freeText.replace('[amount]', money(left)) : drawer.dataset.freeDone;
      $('[data-wsh-free-bar]', drawer).style.width = Math.min(100, cart.total_price / th * 100) + '%';
    }
  }
  async function refreshCart() {
    try { const c = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json(); renderCart(c); return c; } catch (e) { }
  }
  document.addEventListener('click', async e => {
    const b = e.target.closest('.wsh-line [data-q]'); if (!b) return;
    const line = b.closest('.wsh-line'); line.classList.add('is-busy');
    try {
      const res = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.dataset.key, quantity: Math.max(0, +b.dataset.q) }) });
      const cart = await res.json();
      if (!res.ok) throw new Error(cart.description || cart.message);
      renderCart(cart);
    } catch (err) { line.classList.remove('is-busy'); alert(err.message || 'Erreur'); }
  });

  // Warm Style product sections fire this after add-to-cart
  document.addEventListener('ws:cart:added', () => open('cart'));
  // Keep counts in sync with other add-to-cart buttons (Impact & apps)
  ['cart:refresh', 'cart:change', 'cart:updated', 'variant:add'].forEach(ev => {
    document.addEventListener(ev, () => refreshCart());
    document.documentElement.addEventListener(ev, () => refreshCart());
  });
  document.addEventListener('shopify:section:load', tick);

  /* Publish our header height so sticky elements (product gallery, Impact components) sit below it */
  function setHeaderHeight() {
    const h = document.querySelector('.wsh-section-header');
    if (!h) return;
    const px = Math.round(h.getBoundingClientRect().height) + 'px';
    ['--header-height', '--sticky-area-height', '--ws-header-height'].forEach(v => document.documentElement.style.setProperty(v, px));
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
  document.addEventListener('shopify:section:load', setHeaderHeight);

  /* Redirect Impact's cart triggers (quick-add, cart icons) to the Warm Style drawer */
  document.addEventListener('click', e => {
    const t = e.target.closest('[aria-controls="cart-drawer"], a[href$="/cart"]:not([data-wsh-open]):not(.wsh-cart__view)');
    if (!t || !document.querySelector('[data-ws-cart]') || t.closest('[data-wsh-panel]')) return;
    if (t.matches('[aria-controls="cart-drawer"]')) { e.preventDefault(); e.stopPropagation(); open('cart'); }
  }, true);
  ['cart:refresh', 'variant:add'].forEach(ev => document.documentElement.addEventListener(ev, () => {
    if (document.querySelector('[data-ws-cart]') && window.__wsAutoOpen !== false) setTimeout(() => open('cart'), 100);
  }));

  /* Announcement: one message at a time on mobile */
  function initRotate(scope = document) {
    $$('.wsh-announce--rotate', scope).forEach(a => {
      if (a.__wsRot) return; a.__wsRot = true;
      const items = $$('.wsh-announce__item', a); if (items.length < 2) return;
      let i = Math.max(0, items.findIndex(x => x.classList.contains('is-active')));
      setInterval(() => {
        if (!matchMedia('(max-width: 899px)').matches || document.hidden) return;
        items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active');
      }, (+a.dataset.wshRotate || 4) * 1000);
    });
  }
  initRotate();
  document.addEventListener('shopify:section:load', e => initRotate(e.target));
})();
